import { Box, SxProps, Theme } from '@mui/material';
import React from 'react';
import QrCodeSvg from 'react-qr-code';

interface Props {
  value: string;
  id?: string;
  size?: number;
  sx?: SxProps<Theme>;
}

const QRCode: React.FC<Props> = ({ value, size, sx, id }) => (
  <Box
    id={id}
    sx={[
      { backgroundColor: (theme) => theme.palette.common.white, p: 1, lineHeight: 0, display: 'inline-block' },
      ...(Array.isArray(sx) ? sx : [sx])
    ]}
  >
    <QrCodeSvg value={value} size={size} />
  </Box>
);

export default QRCode;
